import type { FaireProductEntity } from "../../entity_types/product";

export const ramen_3: FaireProductEntity = {
  token: "ramen-3",
  type: "product",
  name: "Red Chili Instant Ramen",
  brandName: "Sabahar",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/3e9d69ea8313288c957b3ca024de7911d167ae7c79f188e801c89a856b6a09b5.png",
  priceDollars: 3,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/3e9d69ea8313288c957b3ca024de7911d167ae7c79f188e801c89a856b6a09b5.png",
  weight: 0.2,
  dimensions: {
    width: 5,
    height: 6,
    depth: 2,
  },
  description: "Red chili instant ramen with bold flavor",
  categoryTokens: ["cat_food-snacks"],
  tags: [
    "ramen",
    "instant-ramen",
    "japanese-ramen",
    "spicy",
    "chili",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
